<template>
  <div class="row-bookmeang row-projectmanagement">
    <!-- <LeftListMember  /> -->
    <LeftListMember :pos="4"></LeftListMember>
    <div class="g-row2">
      <div class="m-hone1">
        <div class="contect g-contecte1">
          <div class="m-table">
            <div class="top">
              <div class="tit">项目列表</div>
            </div>
            <div class="inner">
              <a-table :columns="columns" rowKey="id" :data-source="data" :pagination="false" :bordered="false" >
                <div slot="updatetime" class="date" slot-scope="desc, record, indent, expanded,">
                  {{(record.updatetime||'').split(' ')[0]}}  <span class="time">{{(record.updatetime||' ').split(' ')[1]}}</span>
                </div>
                <div slot="status" slot-scope="desc, record, indent, expanded,"
                     :style="{ color: record.customerStatus>0 ? '#9FA6AF' : '#222529' }">
                  <span class="status" @click="viewDetail(record)">{{ record.customerStatusOptionName }}</span>
                </div>
                <div slot="delete" slot-scope="leadingin, record, indent, expanded" class="leadingin" style="color:#1690FF;">
<!--                  <span v-if="record.customerStatus==0" @click="showModal(record)"> 导入 </span>-->
                  <span @click="viewDetail(record)"> 查看 </span>
                </div>
<!--                <router-link to="" slot="delete" slot-scope="index, record, indent, expanded" class="delete"><span-->
<!--                    @click="showModal">查看</span></router-link>-->

              </a-table>
            </div>
          </div>
          <mPages :page.sync="filter.page" :page-size.sync="filter.pageSize" :total="dataCount" />
        </div>
      </div>

    </div>

    <!--查看弹窗-->
    <a-modal :visible="viewVisiable" @ok="viewVisiable=false" @cancel="viewVisiable=false" :footer="null" :centered="true"
             :closable="false" width="90%">
      <div class="inner m-libray">
        <div>
          <div class="top1">
            <div class="tit2">图书目录</div>
            <div class="con2">
              <!-- <div class="btn1" @click="showModal">批量添加</div> -->
              <div class="btn1 " @click="batchAdd">批量添加</div>
            </div>
          </div>
        </div>
        <div class="m-table ">
          <a-table :columns="detailColumns" :data-source="detailData" :pagination="false" :bordered="false"
                   :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" rowKey="id"  :scroll="{ x: 700 }">
            <div slot="supplier" slot-scope="supplier, record, indent, expanded">
              <a @click="openSupplier(order.customerInfo.uid)" class="supplier" >{{ order.customerInfo.realname }}</a>
            </div>
            <div slot="add" slot-scope="index, record, indent, expanded" class="delete" style="color: #188EFC;">
              <span @click="add(record)">{{ record.added ? '' : '添加订单'}}</span>
            </div>
          </a-table>
          <mPages :page.sync="detailPage.page" :page-size.sync="detailPage.pageSize" :total="detailPage.count" />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import LeftListMember from "@/components/LeftListMember";
import mPages from '@/components/mpages/mPages.vue'
import {getApiData, getApiRes} from "@/api/apiUtil";
import apiBkBookChoose from "@/api/bkBookChoose";
export default {
  components: {
    LeftListMember,
    mPages,
  },
  data() {
    return {
      // 表单
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        name: '',
        name2: '',
        name3: '',
        name4: '',
        region: undefined,
        region2: undefined,
      },
      // 表格
      selectedRowKeys: [], // Check here to configure the default column
      columns: [
        {
          title: "目录名称",
          dataIndex: "title",
          key: "title",
          width: '24%',
        },
        {
          title: "供应商",
          dataIndex: "supplierInfo.shortName",
          key: "supplierInfo.shortName",
          width: '17.6%',
          ellipsis: true,
        },
        {
          title: "更新时间",
          dataIndex: "updatetime",
          key: "updatetime",
          width: '17.2%',
          ellipsis: true,
          scopedSlots: { customRender: 'updatetime' },
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          ellipsis: true,
          width: '12.4%',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: "操作",
          dataIndex: "value4",
          key: "value4",
          ellipsis: true,
          width: '21.6%',
          scopedSlots: { customRender: 'delete' },
        },
      ],
      data: [],
      dataCount: 0,
      search: {
        supplier: ''
      },
      filter: {
        isSupplierInfo: true,
        page: 1,
        pageSize: 20,
        order: undefined
      },
      currentData: {},


      // 查看
      viewVisiable: false,
      detailColumns: [
        {
          title: "ISBN",
          dataIndex: "isbn",
          key: "isbn",
          width: 150,

        },
        {
          title: "书名",
          dataIndex: "name",
          key: "name",
          width: 190,
          ellipsis: true,
        },
        {
          title: "出版社",
          dataIndex: "publisher",
          key: "publisher",
          width: 140,
          ellipsis: true,
        },
        {
          title: "作者",
          dataIndex: "author",
          key: "author",
          ellipsis: true,
          width: 87,
        },

        {
          title: "发行时间",
          dataIndex: "publishDate",
          key: "publishDate",
          ellipsis: true,
          width: 110,
        },

        // {
        //   title: "印刷日期",
        //   dataIndex: "printDate",
        //   key: "printDate",
        //   ellipsis: true,
        //   width: 110,
        // },
        {
          title: "开本",
          dataIndex: "pageSize",
          key: "pageSize",
          ellipsis: true,
          width: 73,
        },
        {
          title: "定价",
          dataIndex: "price",
          key: "price",
          ellipsis: true,
          width: 73,
        },
        {
          title: "折扣",
          dataIndex: "discount",
          key: "discount",
          ellipsis: true,
          width: 80,
        },
        // {
        //   title: "客户",
        //   dataIndex: "customer",
        //   key: "customer",
        //   ellipsis: true,
        //   width: 230,
        //   scopedSlots: { customRender: 'supplier' },
        // },
        {
          title: "订单数",
          dataIndex: "num",
          key: "num",
          ellipsis: true,
          width: 80,
        },
        {
          title: "操作",
          dataIndex: "operate",
          key: "operate",
          ellipsis: true,
          width: 90,
          scopedSlots: { customRender: 'add' },
        },
      ],
      detailData: [],
      detailPage: {
        page: 1,
        pageSize: 100,
        count: 0,
      }
    };
  },
  computed: {},
  watch: {
    filter:{
      handler() {
        this.load()
      },
      deep: true
    },
    detailPage: {
      deep: true,
      handler() {
        this.viewDetail(this.currentData, this.detailPage.page)
      }
    }
  },
  mounted() {
    this.load(1)

    // 检测认证
    if(this.$store.state.user.userInfo.type != 2 && this.$store.state.user.company.status != 2) { //会员和供应商需要认证
      return this.$alert('请先完成资质认证', '提示', {callback:()=>this.$router.push(this.$store.state.user.userInfo.type == 1 ? '/info-qualifications' : '/center-qualifications')})
    }

  },

  methods: {
    async load(page=undefined){
      if(page) this.filter.page = page
      let map = []
      // if(this.search.supplier) map.push(['supplier','like',`%${this.search.supplier}%`])
      let re = await getApiRes(apiBkBookChoose.getList(undefined,undefined,map,'',[],this.filter), 0, 1,1)
      this.data = re.data
      this.dataCount = re.count
    },
    async viewDetail(row, page=1){
      this.currentData = row
      this.viewVisiable = true
      let re = await getApiRes(apiBkBookChoose.getDetailList(row.id, page, this.detailPage.pageSize),0,1)
      this.detailData = re.data
      this.detailPage.count = re.count
      if(row.customerStatus == 0) {
        this.setRead(row.id)
        row.customerStatus = 1
        row.customerStatusOptionName = '已查看'
      }
    },
    async setRead(id){
      await getApiRes(apiBkBookChoose.setRead(id),0,0,0,0)
    },
    // 表格
    onSubmit() {
      console.log('submit!', this.form);
    },
    // 表格
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    async add(item){
      let re = await getApiRes(apiBkBookChoose.addCartFromDetail([item.id]),0,1,1,1)
      if(re.code==0){
        this.detailData.forEach(v=>{
          if(item.id == v.id) v.added = 1
        })
      }
    },
    async batchAdd(){
      if(this.selectedRowKeys.length==0) return this.$message.error('请选择要添加的数据')
      let re = await getApiRes(apiBkBookChoose.addCartFromDetail(this.selectedRowKeys),0,1,1,1)
      if(re.code==0){
        this.detailData.forEach(v=>{
          if(this.selectedRowKeys.includes(v.id)) v.added = 1
        })
      }
    },

  },
};
</script>

<style lang="scss" scoped></style>
